import moment from "moment/moment";
import IMask from "imask";

export function unwrapSuccess(enveloped) {
    if (enveloped && enveloped.success) {
        if (enveloped.meta && Object.keys(enveloped.meta).length > 0) {
            enveloped.data.meta = enveloped.meta;
        }
        return enveloped.data;
    }
    return enveloped;
}

export function toLocalInputValue(isoString) {
    if (!isoString) {
        return '';
    }
    return isoString.substring(0, 16);
}

export function formatLocal(isoString, date = false) {
    if (!isoString) return '';
    if (date) return moment(isoString).format('DD.MM.Y');
    return moment(isoString).format('DD.MM.Y HH:mm');
}

export function nowLocal() {
    return moment().format().substring(0, 16);
}

export function getCurrencySymbol(currency) {
    const formatter = new Intl.NumberFormat("ru-RU", {
        style: "currency",
        currency: currency
    });
    const parts = formatter.formatToParts(0);
    return parts.find(p => p.type === 'currency')?.value;
}

export function normalizeAmountInput(fieldRef) {
    IMask(fieldRef.value, {
        mask: Number,
        scale: 2,
        thousandsSeparator: '',
        radix: '.',
        mapToRadix: [','],
        max: 999999999999.99
    });
}

export function getCurrencyFormatted(amount, currency) {
    console.log(amount);
    const formatter = new Intl.NumberFormat("ru-RU", {
        style: "currency",
        currency: currency
    });
    return formatter.format(amount).replace(',', '.');
}
